export default __webpack_public_path__ + "static/media/docker.a6221ab3.svg";